import React, { useState } from 'react';
import { Row, Tabs, Tab } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import InvoicesTab from './SalesInvoice/InvoicesTab';
import ProductsTab from './SalesInvoice/ProductsTab';

const TAB_KEYS = ['invoices', 'products'] as const;
type TabKey = (typeof TAB_KEYS)[number];

const resolveTab = (value: string | null): TabKey => {
  if (value === 'products' || value === 'invoices') {
    return value;
  }
  return 'invoices';
};

const SalesInvoice = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [activeTab, setActiveTab] = useState<TabKey>(
    resolveTab(queryParams.get('tab'))
  );

  const handleTabSelect = (key: string | null) => {
    const nextTab = resolveTab(key);
    setActiveTab(nextTab);
    const nextParams = new URLSearchParams(location.search);
    nextParams.set('tab', nextTab);
    navigate({ search: nextParams.toString() }, { replace: true });
  };

  return (
    <>
      <Row lg="1" className="mb-3">
        <h4>Sales Invoice</h4>
      </Row>
      <Tabs
        activeKey={activeTab}
        onSelect={handleTabSelect}
        className="mb-3"
        justify
      >
        <Tab eventKey="invoices" title="Invoices">
          {activeTab === 'invoices' && <InvoicesTab />}
        </Tab>
        <Tab eventKey="products" title="Products">
          {activeTab === 'products' && <ProductsTab />}
        </Tab>
      </Tabs>
    </>
  );
};

export default SalesInvoice;
